export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNOUT_USER_SUCCESS = "SIGNOUT_USER_SUCCESS";
export const SIGNIN_USER_REQUEST = "SIGNIN_USER_REQUEST";
export const SIGNIN_USER_ERROR = "SIGNIN_USER_ERROR";

export const SIGNIN_ADMIN_SUCCESS = "SIGNIN_ADMIN_SUCCESS";
export const SIGNIN_ADMIN_REQUEST = "SIGNIN_ADMIN_REQUEST";
export const SIGNIN_ADMIN_ERROR = "SIGNIN_ADMIN_ERROR";
export const SET_ADMIN_USER = "SET_ADMIN_USER";

export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SIGNOUT_USER = "SIGNOUT_USER";

export const SEND_USER_OTP_VERIFY = "SEND_USER_OTP_VERIFY";
export const SEND_USER_OTP = "SEND_USER_OTP";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";

export const VENDOR_REGISTER_REQUEST = "VENDOR_REGISTER_REQUEST";
export const VENDOR_REGISTER_SUCCESS = "VENDOR_REGISTER_SUCCESS";
export const VENDOR_REGISTER_FAIL = "VENDOR_REGISTER_FAIL";

export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAIL = "FETCH_USER_FAIL";

export const USER_PROFILE_UPDATE_REQUEST = "USER_PROFILE_UPDATE_REQUEST";
export const USER_PROFILE_UPDATE_SUCCESS = "USER_PROFILE_UPDATE_SUCCESS";
export const USER_PROFILE_UPDATE_FAIL = "USER_PROFILE_UPDATE_FAIL";

export const USER_PASSWORD_UPDATE_REQUEST = "USER_PASSWORD_UPDATE_REQUEST";
export const USER_PASSWORD_UPDATE_SUCCESS = "USER_PASSWORD_UPDATE_SUCCESS";
export const USER_PASSWORD_UPDATE_FAIL = "USER_PASSWORD_UPDATE_FAIL";

export const CANDIDATE_PROFILE_DETAILS_REQUEST = "CANDIDATE_PROFILE_DETAILS_REQUEST";
export const CANDIDATE_PROFILE_DETAILS_SUCCESS = "CANDIDATE_PROFILE_DETAILS_SUCCESS";
export const CANDIDATE_PROFILE_DETAILS_FAIL = "CANDIDATE_PROFILE_DETAILS_FAIL";

export const VENDOR_PROFILE_DETAILS_REQUEST = "VENDOR_PROFILE_DETAILS_REQUEST";
export const VENDOR_PROFILE_DETAILS_SUCCESS = "VENDOR_PROFILE_DETAILS_SUCCESS";
export const VENDOR_PROFILE_DETAILS_FAIL = "VENDOR_PROFILE_DETAILS_FAIL";

export const CANDIDATE_OVERVIEW_UPDATE_REQUEST = "CANDIDATE_OVERVIEW_UPDATE_REQUEST";
export const CANDIDATE_OVERVIEW_UPDATE_SUCCESS = "CANDIDATE_OVERVIEW_UPDATE_SUCCESS";
export const CANDIDATE_OVERVIEW_UPDATE_FAIL = "CANDIDATE_OVERVIEW_UPDATE_FAIL";

export const VENDOR_OVERVIEW_UPDATE_REQUEST = "VENDOR_OVERVIEW_UPDATE_REQUEST";
export const VENDOR_OVERVIEW_UPDATE_SUCCESS = "VENDOR_OVERVIEW_UPDATE_SUCCESS";
export const VENDOR_OVERVIEW_UPDATE_FAIL = "VENDOR_OVERVIEW_UPDATE_FAIL";

export const CANDIDATE_PRO_UPDATE_REQUEST = "CANDIDATE_PRO_UPDATE_REQUEST";
export const CANDIDATE_PRO_UPDATE_SUCCESS = "CANDIDATE_PRO_UPDATE_SUCCESS";
export const CANDIDATE_PRO_UPDATE_FAIL = "CANDIDATE_PRO_UPDATE_FAIL";

export const CANDIDATE_PRO2_UPDATE_REQUEST = "CANDIDATE_PRO2_UPDATE_REQUEST";
export const CANDIDATE_PRO2_UPDATE_SUCCESS = "CANDIDATE_PRO2_UPDATE_SUCCESS";
export const CANDIDATE_PRO2_UPDATE_FAIL = "CANDIDATE_PRO2_UPDATE_FAIL";

export const CANDIDATE_ADD_PROJECT_REQUEST = "CANDIDATE_ADD_PROJECT_REQUEST";
export const CANDIDATE_ADD_PROJECT_SUCCESS = "CANDIDATE_ADD_PROJECT_SUCCESS";
export const CANDIDATE_ADD_PROJECT_FAIL = "CANDIDATE_ADD_PROJECT_FAIL";

export const CANDIDATE_UPDATE_PROJECT_REQUEST = "CANDIDATE_UPDATE_PROJECT_REQUEST";
export const CANDIDATE_UPDATE_PROJECT_SUCCESS = "CANDIDATE_UPDATE_PROJECT_SUCCESS";
export const CANDIDATE_UPDATE_PROJECT_FAIL = "CANDIDATE_UPDATE_PROJECT_FAIL";

export const CLIENT_CANDIDATE_LIST_REQUEST = "CLIENT_CANDIDATE_LIST_REQUEST";
export const CLIENT_CANDIDATE_LIST_SUCCESS = "CLIENT_CANDIDATE_LIST_SUCCESS";
export const CLIENT_CANDIDATE_LIST_FAIL = "CLIENT_CANDIDATE_LIST_FAIL";


export const VENDOR_PRO_UPDATE_REQUEST = "VENDOR_PRO_UPDATE_REQUEST";
export const VENDOR_PRO_UPDATE_SUCCESS = "VENDOR_PRO_UPDATE_SUCCESS";
export const VENDOR_PRO_UPDATE_FAIL = "VENDOR_PRO_UPDATE_FAIL";

export const CANDIDATE_ContactInfo_UPDATE_REQUEST = "CANDIDATE_ContactInfo_UPDATE_REQUEST";
export const CANDIDATE_ContactInfo_UPDATE_SUCCESS = "CANDIDATE_ContactInfo_UPDATE_SUCCESS";
export const CANDIDATE_ContactInfo_UPDATE_FAIL = "CANDIDATE_ContactInfo_UPDATE_FAIL";

export const VENDOR_ContactInfo_UPDATE_REQUEST = "VENDOR_ContactInfo_UPDATE_REQUEST";
export const VENDOR_ContactInfo_UPDATE_SUCCESS = "VENDOR_ContactInfo_UPDATE_SUCCESS";
export const VENDOR_ContactInfo_UPDATE_FAIL = "VENDOR_ContactInfo_UPDATE_FAIL";

export const CANDIDATE_CandidatePersonal_UPDATE_REQUEST = "CANDIDATE_CandidatePersonal_UPDATE_REQUEST";
export const CANDIDATE_CandidatePersonal_UPDATE_SUCCESS = "CANDIDATE_CandidatePersonal_UPDATE_SUCCESS";
export const CANDIDATE_CandidatePersonal_UPDATE_FAIL = "CANDIDATE_CandidatePersonal_UPDATE_FAIL";

export const CANDIDATE_CandidateSkills_UPDATE_REQUEST = "CANDIDATE_CandidateSkills_UPDATE_REQUEST";
export const CANDIDATE_CandidateSkills_UPDATE_SUCCESS = "CANDIDATE_CandidateSkills_UPDATE_SUCCESS";
export const CANDIDATE_CandidateSkills_UPDATE_FAIL = "CANDIDATE_CandidateSkills_UPDATE_FAIL";

export const CREATE_JOB_REQUEST = "CREATE_JOB_REQUEST";
export const CREATE_JOB_SUCCESS = "CREATE_JOB_SUCCESS";
export const CREATE_JOB_FAIL = "CREATE_JOB_FAIL";

export const NEW_JOB_LIST_REQUEST = "NEW_JOB_LIST_REQUEST";
export const NEW_JOB_LIST_SUCCESS = "NEW_JOB_LIST_SUCCESS";
export const NEW_JOB_LIST_FAIL = "NEW_JOB_LIST_FAIL";

export const POSTED_JOB_VIEW_REQUEST = "POSTED_JOB_VIEW_REQUEST";
export const POSTED_JOB_VIEW_SUCCESS = "POSTED_JOB_VIEW_SUCCESS";
export const POSTED_JOB_VIEW_FAIL = "POSTED_JOB_VIEW_FAIL";

export const FOR_WORK_UPDATE_REQUEST = "FOR_WORK_UPDATE_REQUEST";
export const FOR_WORK_UPDATE_SUCCESS = "FOR_WORK_UPDATE_SUCCESS";
export const FOR_WORK_UPDATE_FAIL = "FOR_WORK_UPDATE_FAIL";

export const PROGRESSBAR_VIEW_REQUEST = "PROGRESSBAR_VIEW_REQUEST";
export const PROGRESSBAR_VIEW_SUCCESS = "PROGRESSBAR_VIEW_SUCCESS";
export const PROGRESSBAR_VIEW_FAIL = "PROGRESSBAR_VIEW_FAIL";

export const VENDOR_PROGRESSBAR_VIEW_REQUEST = "VENDOR_PROGRESSBAR_VIEW_REQUEST";
export const VENDOR_PROGRESSBAR_VIEW_SUCCESS = "VENDOR_PROGRESSBAR_VIEW_SUCCESS";
export const VENDOR_PROGRESSBAR_VIEW_FAIL = "VENDOR_PROGRESSBAR_VIEW_FAIL";

export const CANDIDATE_EDUCATION_UPDATE_REQUEST = "CANDIDATE_EDUCATION_UPDATE_REQUEST";
export const CANDIDATE_EDUCATION_UPDATE_SUCCESS = "CANDIDATE_EDUCATION_UPDATE_SUCCESS";
export const CANDIDATE_EDUCATION_UPDATE_FAIL = "CANDIDATE_EDUCATION_UPDATE_FAIL";

export const CANDIDATE_CERTIFICATION_UPDATE_REQUEST = "CANDIDATE_CERTIFICATION_UPDATE_REQUEST";
export const CANDIDATE_CERTIFICATION_UPDATE_SUCCESS = "CANDIDATE_CERTIFICATION_UPDATE_SUCCESS";
export const CANDIDATE_CERTIFICATION_UPDATE_FAIL = "CANDIDATE_CERTIFICATION_UPDATE_FAIL";

export const VIEW_JOB_LIST_REQUEST = "VIEW_JOB_LIST_REQUEST";
export const VIEW_JOB_LIST_SUCCESS = "VIEW_JOB_LIST_SUCCESS";
export const VIEW_JOB_LIST_FAIL = "VIEW_JOB_LIST_FAIL";


export const APPLY_JOB_LIST_REQUEST = "APPLY_JOB_LIST_REQUEST";
export const APPLY_JOB_LIST_SUCCESS = "APPLY_JOB_LIST_SUCCESS";
export const APPLY_JOB_LIST_FAIL = "APPLY_JOB_LIST_FAIL";


export const SCHEDULE_INTERVIEW_REQUEST = "SCHEDULE_INTERVIEW_REQUEST";
export const SCHEDULE_INTERVIEW_SUCCESS = "SCHEDULE_INTERVIEW_SUCCESS";
export const SCHEDULE_INTERVIEW_FAIL = "SCHEDULE_INTERVIEW_FAIL";

export const APPLY_JOB_LIST2_REQUEST = "APPLY_JOB_LIST2_REQUEST";
export const APPLY_JOB_LIST2_SUCCESS = "APPLY_JOB_LIST2_SUCCESS";
export const APPLY_JOB_LIST2_FAIL = "APPLY_JOB_LIST2_FAIL";


export const TEAM_APPLY_JOB_LIST2_REQUEST = "TEAM_APPLY_JOB_LIST2_REQUEST";
export const TEAM_APPLY_JOB_LIST2_SUCCESS = "TEAM_APPLY_JOB_LIST2_SUCCESS";
export const TEAM_APPLY_JOB_LIST2_FAIL = "TEAM_APPLY_JOB_LIST2_FAIL";


export const INTERVIEW_HISTORY_REQUEST = "INTERVIEW_HISTORY_REQUEST";
export const INTERVIEW_HISTORY_SUCCESS = "INTERVIEW_HISTORY_SUCCESS";
export const INTERVIEW_HISTORY_FAIL = "INTERVIEW_HISTORY_FAIL";


export const INTERVIEW_PLANNED_REQUEST = "INTERVIEW_PLANNED_REQUEST";
export const INTERVIEW_PLANNED_SUCCESS = "INTERVIEW_PLANNED_SUCCESS";
export const INTERVIEW_PLANNED_FAIL = "INTERVIEW_PLANNED_FAIL";

export const SEND_REQUEST_REQUEST = "SEND_REQUEST_REQUEST";
export const SEND_REQUEST_SUCCESS = "SEND_REQUEST_SUCCESS";
export const SEND_REQUEST_FAIL = "SEND_REQUEST_FAIL";


export const ADD_TEAM_REQUEST = "ADD_TEAM_REQUEST";
export const ADD_TEAM_SUCCESS = "ADD_TEAM_SUCCESS";
export const ADD_TEAM_FAIL = "ADD_TEAM_FAIL";

export const ADD_TEAM_TABLE_REQUEST = "ADD_TEAM_TABLE_REQUEST";
export const ADD_TEAM_TABLE_SUCCESS = "ADD_TEAM_TABLE_SUCCESS";
export const ADD_TEAM_TABLE_FAIL = "ADD_TEAM_TABLE_FAIL";

export const GET_SKILLS_REQUEST = "GET_SKILLS_REQUEST";
export const GET_SKILLS_SUCCESS = "GET_SKILLS_SUCCESS";
export const GET_SKILLS_FAIL = "GET_SKILLS_FAIL";

export const ADD_SKILLS_REQUEST = "ADD_SKILLS_REQUEST";
export const ADD_SKILLS_SUCCESS = "ADD_SKILLS_SUCCESS";
export const ADD_SKILLS_FAIL = "ADD_SKILLS_FAIL";

export const DELETE_SKILLS_REQUEST = "DELETE_SKILLS_REQUEST";
export const DELETE_SKILLS_SUCCESS = "DELETE_SKILLS_SUCCESS";
export const DELETE_SKILLS_FAIL = "DELETE_SKILLS_FAIL";

export const DELETE_TEAM_REQUEST = "DELETE_TEAM_REQUEST";
export const DELETE_TEAM_SUCCESS = "DELETE_TEAM_SUCCESS";
export const DELETE_TEAM_FAIL = "DELETE_TEAM_FAIL";

export const UPLOAD_REQUEST = "UPLOAD_REQUEST";
export const UPLOAD_SUCCESS = "UPLOAD_SUCCESS";
export const UPLOAD_FAIL = "UPLOAD_FAIL";

export const JOB_WORK_ORDER_REQUEST = "JOB_WORK_ORDER_REQUEST";
export const JOB_WORK_ORDER_SUCCESS = "JOB_WORK_ORDER_SUCCESS";
export const JOB_WORK_ORDER_FAIL = "JOB_WORK_ORDER_FAIL";

export const ADMIN_DASH_REQUEST = "ADMIN_DASH_REQUEST";
export const ADMIN_DASH_SUCCESS = "ADMIN_DASH_SUCCESS";
export const ADMIN_DASH_FAIL = "ADMIN_DASH_FAIL";

export const JOB_REQUEST_REQUEST = "JOB_REQUEST_REQUEST";
export const JOB_REQUEST_SUCCESS = "JOB_REQUEST_SUCCESS";
export const JOB_REQUEST_FAIL = "JOB_REQUEST_FAIL";

export const ADD_EMP_HISTORY_REQUEST = "ADD_EMP_HISTORY_REQUEST";
export const ADD_EMP_HISTORY_SUCCESS = "ADD_EMP_HISTORY_SUCCESS";
export const ADD_EMP_HISTORY_FAIL = "ADD_EMP_HISTORY_FAIL";

export const GET_EMP_HIS_LIST_REQUEST = "GET_EMP_HIS_LIST_REQUEST";
export const GET_EMP_HIS_LIST_SUCCESS = "GET_EMP_HIS_LIST_SUCCESS";
export const GET_EMP_HIS_LIST_FAIL = "GET_EMP_HIS_LIST_FAIL";

export const EMP_HISTORY_UPDATE_REQUEST = "EMP_HISTORY_UPDATE_REQUEST";
export const EMP_HISTORY_UPDATE_SUCCESS = "EMP_HISTORY_UPDATE_SUCCESS";
export const EMP_HISTORY_UPDATE_FAIL = "EMP_HISTORY_UPDATE_FAIL";

export const JOB_DESCRIPTION_REQUEST = "JOB_DESCRIPTION_REQUEST";
export const JOB_DESCRIPTION_SUCCESS = "JOB_DESCRIPTION_SUCCESS";
export const JOB_DESCRIPTION_FAIL = "JOB_DESCRIPTION_FAIL";

export const UPDATE_ACCEPT_REQUEST = "UPDATE_ACCEPT_REQUEST";
export const UPDATE_ACCEPT_SUCCESS = "UPDATE_ACCEPT_SUCCESS";
export const UPDATE_ACCEPT_FAIL = "UPDATE_ACCEPT_FAIL";

export const NEW_SCHEDULE_INTERVIEW_REQUEST = "NEW_SCHEDULE_INTERVIEW_REQUEST";
export const NEW_SCHEDULE_INTERVIEW_SUCCESS = "NEW_SCHEDULE_INTERVIEW_SUCCESS";
export const NEW_SCHEDULE_INTERVIEW_FAIL = "NEW_SCHEDULE_INTERVIEW_FAIL";

export const APPLIED_JOB_REQUEST_REQUEST = "APPLIED_JOB_REQUEST_REQUEST";
export const APPLIED_JOB_REQUEST_SUCCESS = "APPLIED_JOB_REQUEST_SUCCESS";
export const APPLIED_JOB_REQUEST_FAIL = "APPLIED_JOB_REQUEST_FAIL";

export const CANDIDATE_JOB_HISTORY_REQUEST = "CANDIDATE_JOB_HISTORY_REQUEST";
export const CANDIDATE_JOB_HISTORY_SUCCESS = "CANDIDATE_JOB_HISTORY_SUCCESS";
export const CANDIDATE_JOB_HISTORY_FAIL = "CANDIDATE_JOB_HISTORY_FAIL";

export const CANDIDATE_JOB_PLANNED_REQUEST = "CANDIDATE_JOB_PLANNED_REQUEST";
export const CANDIDATE_JOB_PLANNED_SUCCESS = "CANDIDATE_JOB_PLANNED_SUCCESS";
export const CANDIDATE_JOB_PLANNED_FAIL = "CANDIDATE_JOB_PLANNED_FAIL";

export const INTERVIEWER_JOB_PLANNED_REQUEST = "INTERVIEWER_JOB_PLANNED_REQUEST";
export const INTERVIEWER_JOB_PLANNED_SUCCESS = "INTERVIEWER_JOB_PLANNED_SUCCESS";
export const INTERVIEWER_JOB_PLANNED_FAIL = "INTERVIEWER_JOB_PLANNED_FAIL";

export const CANDIDATE_JOB_PLANNED_V2_REQUEST = "CANDIDATE_JOB_PLANNED_V2_REQUEST";
export const CANDIDATE_JOB_PLANNED_V2_SUCCESS = "CANDIDATE_JOB_PLANNED_V2_SUCCESS";
export const CANDIDATE_JOB_PLANNED_V2_FAIL = "CANDIDATE_JOB_PLANNED_V2_FAIL";

export const CANDIDATE_INTERVIEW_REQUEST = "CANDIDATE_INTERVIEW_REQUEST";
export const CANDIDATE_INTERVIEW_SUCCESS = "CANDIDATE_INTERVIEW_SUCCESS";
export const CANDIDATE_INTERVIEW_FAIL = "CANDIDATE_INTERVIEW_FAIL";

export const ADD_RATING_REQUEST = "ADD_RATING_REQUEST";
export const ADD_RATING_SUCCESS = "ADD_RATING_SUCCESS";
export const ADD_RATING_FAIL = "ADD_RATING_FAIL";

export const UPDATE_REJECT_REQUEST = "UPDATE_REJECT_REQUEST";
export const UPDATE_REJECT_SUCCESS = "UPDATE_REJECT_SUCCESS";
export const UPDATE_REJECT_FAIL = "UPDATE_REJECT_FAIL";

export const VENDOR_JOB_DETAILS_REQUEST = "VENDOR_JOB_DETAILS_REQUEST";
export const VENDOR_JOB_DETAILS_SUCCESS = "VENDOR_JOB_DETAILS_SUCCESS";
export const VENDOR_JOB_DETAILS_FAIL = "VENDOR_JOB_DETAILS_FAIL";

export const VENDOR_JOB_UPDATE_REQUEST = "VENDOR_JOB_UPDATE_REQUEST";
export const VENDOR_JOB_UPDATE_SUCCESS = "VENDOR_JOB_UPDATE_SUCCESS";
export const VENDOR_JOB_UPDATE_FAIL = "VENDOR_JOB_UPDATE_FAIL";

export const INTERVIEW_NEW_UPDATE_REQUEST = "INTERVIEW_NEW_UPDATE_REQUEST";
export const INTERVIEW_NEW_UPDATE_SUCCESS = "INTERVIEW_NEW_UPDATE_SUCCESS";
export const INTERVIEW_NEW_UPDATE_FAIL = "INTERVIEW_NEW_UPDATE_FAIL";

export const VERIFY_RESET_OTP_REQUEST = "VERIFY_RESET_OTP_REQUEST";
export const VERIFY_RESET_OTP_SUCCESS = "VERIFY_RESET_OTP_SUCCESS";
export const VERIFY_RESET_OTP_FAIL = "VERIFY_RESET_OTP_FAIL";

export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAIL = "VERIFY_OTP_FAIL";

export const VENDOR_VERIFY_OTP_REQUEST = "VENDOR_VERIFY_OTP_REQUEST";
export const VENDOR_VERIFY_OTP_SUCCESS = "VENDOR_VERIFY_OTP_SUCCESS";
export const VENDOR_VERIFY_OTP_FAIL = "VENDOR_VERIFY_OTP_FAIL";

export const FORGOT_PASS_REQUEST = "FORGOT_PASS_REQUEST";
export const FORGOT_PASS_SUCCESS = "FORGOT_PASS_SUCCESS";
export const FORGOT_PASS_FAIL = "FORGOT_PASS_FAIL";

export const NEW_PASS_UPDATE_REQUEST = "NEW_PASS_UPDATE_REQUEST";
export const NEW_PASS_UPDATE_SUCCESS = "NEW_PASS_UPDATE_SUCCESS";
export const NEW_PASS_UPDATE_FAIL = "NEW_PASS_UPDATE_FAIL";

export const CANDIDATE_TEAM_UPDATE_REQUEST = "CANDIDATE_TEAM_UPDATE_REQUEST";
export const CANDIDATE_TEAM_UPDATE_SUCCESS = "CANDIDATE_TEAM_UPDATE_SUCCESS";
export const CANDIDATE_TEAM_UPDATE_FAIL = "CANDIDATE_TEAM_UPDATE_FAIL";

export const CANDIDATE_PRO_IMG_REQUEST = "CANDIDATE_PRO_IMG_REQUEST";
export const CANDIDATE_PRO_IMG_SUCCESS = "CANDIDATE_PRO_IMG_SUCCESS";
export const CANDIDATE_PRO_IMG_FAIL = "CANDIDATE_PRO_IMG_FAIL";

export const ALL_CANDI_REQUEST_REQUEST = "ALL_CANDI_REQUEST_REQUEST";
export const ALL_CANDI_REQUEST_SUCCESS = "ALL_CANDI_REQUEST_SUCCESS";
export const ALL_CANDI_REQUEST_FAIL = "ALL_CANDI_REQUEST_FAIL";

export const ARCHIVED_MEMBERS_REQUEST = "ARCHIVED_MEMBERS_REQUEST";
export const ARCHIVED_MEMBERS_SUCCESS = "ARCHIVED_MEMBERS_SUCCESS";
export const ARCHIVED_MEMBERS_FAIL = "ARCHIVED_MEMBERS_FAIL";

export const VENDOR_PRO_IMG_REQUEST = "VENDOR_PRO_IMG_REQUEST";
export const VENDOR_PRO_IMG_SUCCESS = "VENDOR_PRO_IMG_SUCCESS";
export const VENDOR_PRO_IMG_FAIL = "VENDOR_PRO_IMG_FAIL";

export const VENDOR_COM_LOGO_REQUEST = "VENDOR_COM_LOGO_REQUEST";
export const VENDOR_COM_LOGO_SUCCESS = "VENDOR_COM_LOGO_SUCCESS";
export const VENDOR_COM_LOGO_FAIL = "VENDOR_COM_LOGO_FAIL";

export const JOBS_INTERVIEW_ACCEPT_REQUEST = "JOBS_INTERVIEW_ACCEPT_REQUEST";
export const JOBS_INTERVIEW_ACCEPT_SUCCESS = "JOBS_INTERVIEW_ACCEPT_SUCCESS";
export const JOBS_INTERVIEW_ACCEPT_FAIL = "JOBS_INTERVIEW_ACCEPT_FAIL";

export const ALL_JOBS_REQUEST = "ALL_JOBS_REQUEST";
export const ALL_JOBS_SUCCESS = "ALL_JOBS_SUCCESS";
export const ALL_JOBS_FAIL = "ALL_JOBS_FAIL";

export const WORK_PREFRENCE_REQUEST = "WORK_PREFRENCE_REQUEST";
export const WORK_PREFRENCE_SUCCESS = "WORK_PREFRENCE_SUCCESS";
export const WORK_PREFRENCE_FAIL = "WORK_PREFRENCE_FAIL";

export const UPDATE_WORK_PREFRENCE_REQUEST = "UPDATE_WORK_PREFRENCE_REQUEST";
export const UPDATE_WORK_PREFRENCE_SUCCESS = "UPDATE_WORK_PREFRENCE_SUCCESS";
export const UPDATE_WORK_PREFRENCE_FAIL = "UPDATE_WORK_PREFRENCE_FAIL";

export const CURRENCY_REQUEST = "CURRENCY_REQUEST";
export const CURRENCY_SUCCESS = "CURRENCY_SUCCESS";
export const CURRENCY_FAIL = "CURRENCY_FAIL";

export const CANDI_WORK_PREFERENCE_REQUEST = "CANDI_WORK_PREFERENCE_REQUEST";
export const CANDI_WORK_PREFERENCE_SUCCESS = "CANDI_WORK_PREFERENCE_SUCCESS";
export const CANDI_WORK_PREFERENCE_FAIL = "CANDI_WORK_PREFERENCE_FAIL";


// export const GET_WORK_PREFERENCE_REQUEST = "GET_WORK_PREFERENCE_REQUEST";
// export const GET_WORK_PREFERENCE_SUCCESS = "GET_WORK_PREFERENCE_SUCCESS";
// export const GET_WORK_PREFERENCE_FAIL = "GET_WORK_PREFERENCE_FAIL";


export const FEEDBACK_DATA_SUCCESS = "FEEDBACK_DATA_SUCCESS"

export const APPLIED_JOBS_VENDOR_REQUEST = "CANDI_WORK_PREFERENCE_REQUEST";
export const APPLIED_JOBS_VENDOR_SUCCESS = "CANDI_WORK_PREFERENCE_SUCCESS";
export const APPLIED_JOBS_VENDOR_FAIL = "CANDI_WORK_PREFERENCE_FAIL";

export const CANCEL_INTERVIEW_VENDOR_REQUEST = "CANCEL_INTERVIEW_VENDOR_REQUEST";
export const CANCEL_INTERVIEW_VENDOR_SUCCESS = "CANCEL_INTERVIEW_VENDOR_SUCCESS";
export const CANCEL_INTERVIEW_VENDOR_FAIL = "CANCEL_INTERVIEW_VENDOR_FAIL";

export const VENDOR_ADD_TEAM_TABLE_REQUEST = "VENDOR_ADD_TEAM_TABLE_REQUEST";
export const VENDOR_ADD_TEAM_TABLE_SUCCESS = "VENDOR_ADD_TEAM_TABLE_SUCCESS";
export const VENDOR_ADD_TEAM_TABLE_FAIL = "VENDOR_ADD_TEAM_TABLE_FAIL";

export const INVITAIONS_REQUEST = "INVITAIONS_REQUEST";
export const INVITAIONS_SUCCESS = "INVITAIONS_SUCCESS";
export const INVITAIONS_FAIL = "INVITAIONS_FAIL";

export const REQUESTED_REQUEST = "REQUESTED_REQUEST";
export const REQUESTED_SUCCESS = "REQUESTED_SUCCESS";
export const REQUESTED_FAIL = "REQUESTED_FAIL";

export const EDIT_JOB_REQUEST = "EDIT_JOB_REQUEST";
export const EDIT_JOB_SUCCESS = "EDIT_JOB_SUCCESS";
export const EDIT_JOB_FAIL = "EDIT_JOB_FAIL";

//  Admin Dashboard constant variable...
export const VIEW_VENDORLIST_REQUEST = "VIEW_VENDORLIST_REQUEST";
export const VIEW_VENDORLIST_SUCCESS = "VIEW_VENDORLIST_SUCCESS";
export const VIEW_VENDORLIST_FAIL = "VIEW_VENDORLIST_FAIL";

export const VIEW_CANDIDATELIST_REQUEST = "VIEW_CANDIDATELIST_REQUEST";
export const VIEW_CANDIDATELIST_SUCCESS = "VIEW_CANDIDATELIST_SUCCESS";
export const VIEW_CANDIDATELIST_FAIL = "VIEW_CANDIDATELIST_FAIL";

export const VIEW_JOBLIST_REQUEST = "VIEW_JOBLIST_REQUEST";
export const VIEW_JOBLIST_SUCCESS = "VIEW_JOBLIST_SUCCESS"
export const VIEW_JOBLIST_FAIL = "VIEW_JOBLIST_FAIL";

export const TEAM_MEMBER_INTERVIEW_REQUEST = "TEAM_MEMBER_INTERVIEW_REQUEST";
export const TEAM_MEMBER_INTERVIEW_SUCCESS = "TEAM_MEMBER_INTERVIEW_SUCCESS";
export const TEAM_MEMBER_INTERVIEW_FAIL = "TEAM_MEMBER_INTERVIEW_FAIL";

export const PURCHASE_ORDER_REQUEST = "PURCHASE_ORDER_REQUEST";
export const PURCHASE_ORDER_SUCCESS = "PURCHASE_ORDER_SUCCESS";
export const PURCHASE_ORDER_FAIL = "PURCHASE_ORDER_FAIL";

export const MASTER_SkillDETAILS_REQUEST = "MASTER_SkillDETAILS_REQUEST"
export const MASTER_SkillDETAILS_SUCCESS = "MASTER_SkillDETAILS_SUCCESS"
export const MASTER_SkillDETAILS_FAIL = "MASTER_SkillDETAILS_FAIL"


export const MASTER_DEPARTMENT_REQUEST = "MASTER_DEPARTMENT_REQUEST"
export const MASTER_DEPARTMENT_SUCCESS = "MASTER_DEPARTMENT_SUCCESS"
export const MASTER_DEPARTMENT_FAIL = "MASTER_DEPARTMENT_FAIL"

export const MASTER_DESIGNATION_REQUEST = "MASTER_DESIGNATION_REQUEST"
export const MASTER_DESIGNATION_SUCCESS = "MASTER_DESIGNATION_SUCCESS"
export const MASTER_DESIGNATION_FAIL = "MASTER_DESIGNATION_FAIL"

export const SUBSCRIPTION_LISTING_REQUEST = "SUBSCRIPTION_LISTING_REQUEST"
export const SUBSCRIPTION_LISTING_SUCCESS = "SUBSCRIPTION_LISTING_SUCCESS"
export const SUBSCRIPTION_LISTING_FAIL = "SUBSCRIPTION_LISTING_FAIL"

export const ADD_VISA_INFORMATION_REQUEST="ADD_VISA_INFORMATION_REQUEST";
export const ADD_VISA_INFORMATION_SUCESS="ADD_VISA_INFORMATION_SUCCESS";
export const ADD_VISA_INFORMATION_FAIL="ADD_VISA_INFORMATION_FAIL";

export const VISA_REQUEST = "VISA_REQUEST";
export const VISA_SUCCESS = "VISA_SUCCESS";
export const VISA_FAIL = "VISA_FAIL";

export const TRAVEL_REQUEST = "TRAVEL_REQUEST";
export const TRAVEL_SUCCESS = "TRAVEL_SUCCESS";
export const TRAVEL_FAIL = "TRAVEL_FAIL";

export const INTERVIEW_APPROVAL_REQUEST = "INTERVIEW_APPROVAL_REQUEST";
export const INTERVIEW_APPROVAL_SUCCESS = "INTERVIEW_APPROVAL_SUCCESS";
export const INTERVIEW_APPROVAL_FAILURE = "INTERVIEW_APPROVAL_FAILURE";


